import {registerTemplateGraphNode} from "#template/template-node/register"
import {curveGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {CurveGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {AttributeSetLambdaParameters} from "#template/nodes/geometry-graph/attribute-set/attribute-set-lambda/geometry-attribute-set-lambda-node"
import {
    GeometryAttributeSetLambdaNode,
    attributeSetLambdaParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/attribute-set-lambda/geometry-attribute-set-lambda-node"

export type CurveGeometryAttributeSetLambdaParameters = AttributeSetLambdaParameters<1>

const definition: TemplateNodeDefinition<CurveGeometryAttributeSetLambdaParameters> = {
    nodeClass: "CurveGeometryAttributeSetLambda",
    validation: {
        parameters: attributeSetLambdaParametersSchema<1>(),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometryAttributeSetLambda
    extends GeometryAttributeSetLambdaNode<1, CurveGeometryAttributeSetLambdaParameters>
    implements CurveGeometryAttributeSetLikeNode
{
    get [curveGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
